import { createSelector } from '@ngrx/store';
import { BookingTariff } from '@products/models/booking.model';
import { getBookedTariff } from '@store/products/booking/product/product-booking.selectors';

/**
 * Get booked tariff workshops
 * @description Get booked tariff assigned workshops
 * @param ticketTypeId
 * @param ticketPersonId
 * @param voucherCode
 * @param packageNumber
 * @param packageIndex
 * @returns Workshops or empty array
 */
export const getBookedTariffWorkshops = (
  ticketTypeId: number,
  ticketPersonId: number,
  voucherCode?: string,
  packageNumber?: number,
  packageIndex?: number
) =>
  createSelector(
    getBookedTariff(ticketTypeId, ticketPersonId, voucherCode, packageNumber, packageIndex),
    (tariff: BookingTariff) => tariff.workshops.length || []
  );

/**
 * Get booked tariff workshop validity
 * @description Get is booked tariff workshop valid
 * @param isWorkshopsSelectionMandatory
 * @param isWorkshopsSelectionMandatoryForZeroPriceTickets
 * @param ticketTypeId
 * @param ticketPersonId
 * @param voucherCode
 * @param packageNumber
 * @param packageIndex
 * @returns Boolean
 */
export const areBookedTariffWorkshopsValid = (
  isWorkshopsSelectionMandatory: boolean,
  isWorkshopsSelectionMandatoryForZeroPriceTickets: boolean,
  isWorkshopTariff: boolean,
  isZeroPriceTicket: boolean,
  ticketTypeId: number,
  ticketPersonId: number,
  voucherCode?: string,
  packageNumber?: number,
  packageIndex?: number
) =>
  createSelector(
    getBookedTariff(ticketTypeId, ticketPersonId, voucherCode, packageNumber, packageIndex),
    (bookedTariff: BookingTariff) => {
      if (!isWorkshopTariff) {
        return true;
      }

      if (isWorkshopsSelectionMandatory || (isWorkshopsSelectionMandatoryForZeroPriceTickets && isZeroPriceTicket)) {
        if (bookedTariff && !bookedTariff.workshops.length) {
          return false;
        }
      }

      return true;
    }
  );
